import { get, post } from '../utils/axios'

export const createEjipFundAPI = async (body) => {
  return await post('createEjipFund', body)
}
export const getEjipFundAPI = async (body) => {
  return await get('getEjipFund', body)
}
export const updateEjipFundAPI = async (body) => {
  return await post('updateEjipFund', body)
}
export const getEjipFundStatusAPI = async () => {
  return await get('getEjipFundStatus')
}
export const getEjipRoundsAPI = async (body) => {
  return await get('getEjipRounds', body)
}
export const getEjipRoundsViewAllAPI = async (body) => {
  return await get('getEjipRoundsViewAll', body)
}
export const createEjipRoundAPI = async (body) => {
  return await post('createEjipRound', body)
}
export const updateEjipRoundAPI = async (body) => {
  return await post('updateEjipRound', body)
}
export const createEjipMemberAPI = async (body) => {
  return await post('createEjipMember', body)
}
export const getEjipMemberAPI = async (body) => {
  return await get('getEjipMember', body)
}
export const getEjipMeberByRoundAPI = async (body) => {
  return await get('getEjipMeberByRound', body)
}
export const getEjipMeberEMPAPI = async (body) => {
  return await get('ejip/member/emp', body)
}


export const deleteEjipMemberAPI = async (body) => {
  return await post('deleteEjipMember', body)
}

export const updateEjipMemberAPI = async (body) => {
  return await post('updateEjipMember', body)
}
